import React from "react";
import { ChatMessage } from "@/types/chat";
import { useAuthStore } from "@/store/authStore";
import { useChatStore } from "@/store/chat";
import { cn } from "@/lib/currencyFormatter";

interface MessageReactionsProps {
  message: ChatMessage;
}

export const MessageReactions: React.FC<MessageReactionsProps> = ({
  message,
}) => {
  const { user } = useAuthStore();
  const { addReaction, removeReaction } = useChatStore();

  if (!message.reactions || message.reactions.length === 0) {
    return null;
  }

  // Group reactions by emoji
  const groupedReactions = message.reactions.reduce((acc, reaction) => {
    if (!acc[reaction.emoji]) {
      acc[reaction.emoji] = [];
    }
    acc[reaction.emoji].push(reaction);
    return acc;
  }, {} as Record<string, typeof message.reactions>);

  return (
    <div className="reactions-container">
      {Object.entries(groupedReactions).map(([emoji, reactions]) => {
        const userReaction = reactions.find((r) => r.user_id === user?.id);
        const isActive = Boolean(userReaction);

        return (
          <button
            key={emoji}
            className={cn("reaction-pill", isActive && "active")}
            onClick={() => {
              if (isActive && userReaction) {
                removeReaction(userReaction.id);
              } else {
                addReaction(message.id, emoji);
              }
            }}
          >
            {emoji}
            <span className="reaction-count">{reactions.length}</span>
          </button>
        );
      })}
    </div>
  );
};
